import { render, staticRenderFns } from "./renovarLicenca.vue?vue&type=template&id=5214ff97&scoped=true&"
import script from "./renovarLicenca.vue?vue&type=script&lang=js&"
export * from "./renovarLicenca.vue?vue&type=script&lang=js&"
import style0 from "./renovarLicenca.vue?vue&type=style&index=0&id=5214ff97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5214ff97",
  null
  
)

export default component.exports